import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { globalSearchSchema } from '~/entities/catalog/url-search';
import { useDocumentHead } from '~/entities/seo/use-document-head';
import type { AppRouterContext } from '~/router';
import { Footer } from '~/widgets/footer';
import { Header } from '~/widgets/header';

const RootLayout = () => {
  useDocumentHead();

  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      {/* Pages using CatalogPageLayout stretch to the footer so the sidebar border never stops mid-page.
          At least a screen high: while a page loads its data it is short, and a footer shown in view and then
          pushed down by the content was the whole layout shift (CLS 0.63) of product and subcategory pages. */}
      <main className="min-h-svh flex-1 has-[[data-catalog-layout]]:flex has-[[data-catalog-layout]]:flex-col">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export const Route = createRootRouteWithContext<AppRouterContext>()({
  validateSearch: (search: Record<string, unknown>) => {
    const parsed = globalSearchSchema.safeParse(search);

    return parsed.success ? parsed.data : {};
  },
  component: RootLayout,
});
